import { SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { StackableViewInterface } from "interfaces/stackableViewInterface";
import { ViewHeaderInterface, ViewHeaderPlacement } from "interfaces/viewHeaderInterface";
import { withVar } from "themes/helpers";

import { ViewHeader } from "./view-header";

const StyledViewContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  border-color: ${withVar(DesignToken.BorderBasicSecondary)};
`;

const StyledHeader = styled.div`
  height: 52px;
`;

const StyledContent = styled.div`
  position: relative;
  height: calc(100% - 52px);
  z-index: 0;
`;

export interface IProps extends StackableViewInterface {
  customHeader?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: string;
  backButton?: React.ReactElement;
  leftNodes?: React.ReactNode;
  rightNodes?: React.ReactNode;
  contentClassName?: string;
  contentCss?: SerializedStyles;
  placement?: ViewHeaderPlacement;
  children?: React.ReactNode;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isViewHeader = (node: any): node is React.ReactElement<ViewHeaderInterface> => node;

const headerWithProps = (headerProps: ViewHeaderInterface, customHeader?: React.ReactNode): React.ReactNode => {
  if (customHeader) {
    if (isViewHeader(customHeader)) {
      return React.cloneElement(customHeader, headerProps);
    }
    return customHeader;
  }
  return <ViewHeader {...headerProps} />;
};

export default class ViewContainer extends React.PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const {
      customHeader,
      title,
      subtitle,
      stackShowBackButton,
      backButton,
      leftNodes,
      rightNodes,
      contentClassName,
      contentCss,
      placement,
      children,
    } = this.props;

    return (
      <StyledViewContainer>
        <StyledHeader>
          {headerWithProps(
            {
              title,
              subtitle,
              showBackButton: stackShowBackButton !== undefined ? stackShowBackButton : false,
              backButton,
              leftNodes,
              rightNodes,
              placement,
            },
            customHeader
          )}
        </StyledHeader>
        <StyledContent className={contentClassName} css={contentCss}>
          {children}
        </StyledContent>
      </StyledViewContainer>
    );
  }
}
